import { SubscriptionFeeSubType } from "@domains/entities/interfaces/Reports/SubscriptionReport/ISubscriptionReport";
export const subscriptionFeesTabs = [
    {
        title: "Rate Based",
        eventKey: SubscriptionFeeSubType.RATE,
    },
    {
        title: "Volume Based",
        eventKey: SubscriptionFeeSubType.VOLUME,
    },
];
export const rateAccordianBodyMob = [
    {
        fieldNameL: "Fees",
        keyL: "chequeAmt",
        fieldNameR: "Balance Fees",
        keyR: "balance",
    },
    {
        fieldNameL: "Start date",
        keyL: "startDate",
        fieldNameR: "End date",
        keyR: "endDate",
        avoidReportValue: true,
    },
    {
        fieldNameL: "Consumed Fees",
        keyL: "consumed",
        fieldNameR: "",
        keyR: "",
    },
];
export const volAccordianBodyMob = [
    {
        fieldNameL: "Fees",
        keyL: "chequeAmt",
        fieldNameR: "Balance Volume",
        keyR: "balance_Vol",
    },
    {
        fieldNameL: "Start date",
        keyL: "startDate",
        fieldNameR: "End date",
        keyR: "endDate",
    },
    {
        fieldNameL: "Allowed Volume",
        keyL: "allowed_Vol",
        fieldNameR: "Consumed Fees",
        keyR: "consumed_Vol",
    },
];
